<template>
  <div class="tkSelectableList">
    <ul
      v-for="row in splitTheItems(items)"
      :key="row.map(item => item.id).join('|')"
      class="tkSelectableList_listArea"
      :style="gridTemplateColumnsNumber"
    >
      <!-- ref は jest の便宜を図るため -->
      <li
        v-for="{ id, name } in row"
        :key="id"
        :ref="id"
        class="tkSelectableList_listItem"
        @click="$emit('selected', id)"
      >
        <span class="tkSelectableList_label">{{ name }}</span>
        <tk-right-arrow class="tkSelectableList_arrow"/>
      </li>
      <!-- 複数列の場合に必要になる端数分の詰め物 -->
      <li
        v-for="i in calculateNumberOfRequiredPadding(row)"
        :key="i"
        class="tkSelectableList_dummyListItem"
      ></li>
    </ul>
  </div>
</template>

<script>
import { TkRightArrow } from '@ota-frontend/ui'

export default {
  name: 'TkSelectableList',
  components: {
    TkRightArrow
  },
  props: {
    numberOfColumns: {
      type: Number,
      default: 2,
    },
    items: {
      type: Array,  // [{ id, name }, ...]
      required: true,
    },
  },
  computed: {
    gridTemplateColumnsNumber() {
      return {
        '--grid-template-columns-number': this.numberOfColumns
      }
    },
  },
  methods: {
    * splitTheItems() {
      for (let index = 0; index < this.items.length; index += this.numberOfColumns) {
        yield this.items.slice(index, index + this.numberOfColumns)
      }
    },
    calculateNumberOfRequiredPadding(row) {
      return this.numberOfColumns - row.length
    },
  },
}
</script>

<style scoped lang="scss">
.tkSelectableList_listArea {
  letter-spacing: -.4em;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(var(--grid-template-columns-number), 1fr);
}
.tkSelectableList_listItem {
  letter-spacing: normal;
  color: #5b2e23;
  border-right: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
  border-top: 0 none;
  background-color: #fff;
  max-height: 45px;
  font-size: 14px;
  height: 45px;
  position: relative;
  width: 100%;
  display: table;
  cursor: pointer;
}
.tkSelectableList_dummyListItem {
  width: 100%;
  border-right: 1px solid transparent;
}
.tkSelectableList_label {
  display: table-cell;
  padding-left: 12px;
  padding-right: 36px;
  vertical-align: middle;
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro",
    "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", Osaka, sans-serif;
}
.tkSelectableList_arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);

  &::before {
    box-sizing: initial;
  }
  &::after {
    box-sizing: initial;
  }
}
</style>
